import TilePageTemplate from "../../../../core/tiles/Template/TilePageTemplate";

import StreamInfo from "./StreamInfo";
import StreamPage from "./StreamPage";
import StreamSettings from "./StreamSettings";

export default function StreamApp({ onUninstall, showHeader = true, showUninstall }) {
  return (
    <TilePageTemplate
      tileId="church-stream"
      title="Stream"
      PageComponent={StreamPage}
      SettingsComponent={StreamSettings}
      InfoComponent={StreamInfo}
      onUninstall={onUninstall}
      showHeader={showHeader}
      showUninstall={showUninstall}
    />
  );
}
